<div class="mb-1 d-flex justify-content-between" [class]="flexDirection">
  <strong *scText="label"></strong>
  <div class="d-flex justify-content-between">
    @if (beforeDiscountCost && hasDiscount) {
      <s class="text-end">{{ beforeDiscountCost | roundedCurrency }}</s>
    }
    @if (cost) {
      <strong class="offer-overview-cost--branded text-end">
        {{ cost | roundedCurrency }}
      </strong>
    }
  </div>
</div>
